module.exports = __webpack_public_path__ + "img/linkedInIcon.8c45158e.svg";